import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';

export const LeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  ${media.mediumDesktop`
    flex-direction: row;
  `}
`;
export const RightBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & div {
    margin-right: 1vw;
    color: ${colors.dustyGray};
  }
  ${media.mediumDesktop`
    flex-direction: row;
  `}
`;
export const Policy = styled.div`
  padding-bottom: 0.25rem;
`;
export const PolicyLink = styled.a`
  color: ${colors.black};
  text-decoration: none;
  font-size: 14px;
  transition: color 150ms ease;
  :hover {
    text-decoration: underline;
  }
`;
export const Images = styled.div`
  & img {
    margin-right: 4vw;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  margin-top: 1vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  ${media.mediumDesktop`
    & img {
      margin-right: 1vw;
    }
    margin-top: 0;
    display: block;
  `}
`;
export const Container = styled.div`
  .StripeElement {
    box-sizing: border-box;
    height: 40px;
    padding: 10px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    background-color: ${colors.white};
    box-shadow: 0 1px 3px 0 #e6ebf1;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }

  .paypal-buttons {
    transition: none !important;
  }
`;
export const RadioButtons = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  ${media.mediumHigh`
    font-size: 16px;
  `}
`;
export const PaymentBlock = styled.div`
  div:first-child {
    margin-top: 15px;
  }
`;
export const PaymentType = styled.div`
  margin-right: 2vw;
  & label {
    color: ${colors.emperor} !important;
  }
`;
export const NumInput = styled.div`
  margin-bottom: 1rem;
`;
export const FakeInputStyle = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.alto};
  border-radius: 10px;
  color: ${colors.dustyGray};
  padding: 11px;
  line-height: 1;
  transition: border-color 0.15s ease;
  :hover {
    cursor: pointer;
    border-color: ${colors.pacificBlue};
  }
  &:focus-within {
    border-color: ${colors.pacificBlue};
  }
`;

export const FakeSelectContainer = styled.button`
  background: none;
  padding: 0;
  margin: 0;
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  &:focus-visible {
    outline: none;
  }
`;
export const FakeSelectText = styled.div`
  text-align: start;
  flex: 1 1 auto;
  font-size: 1rem;
  font-weight: 400;
  color: ${colors.pacificBlue};
`;
export const FakeSelectArrow = styled.div`
  flex: 0 0 auto;
  svg {
    vertical-align: unset !important;
    width: 1.2rem !important;
    height: 1.2rem !important;
  }
`;
export const Alert = styled.div`
  margin: 0.5rem 0;
  color: ${colors.emperor};
  & svg {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }
`;

export const PaymentOptionsHeading = styled.div`
  margin-bottom: 1rem;
`;

export const CheckboxContainer = styled.div`
  font-size: 14px;
  ${media.mediumHigh`
    font-size: 16px;
  `}
  & > div, div {
    display: flex;
    align-items: center;
  }
  & label {
    margin: 0 !important;
    color: ${colors.emperor};
    font-weight: normal !important;
  }
  div div:first-child label {
    width: 1.5rem !important;
    height: 1.5rem !important;
    border-radius: 4px !important;
    color: ${colors.pacificBlue};
    svg {
      width: 1.2rem !important;
      height: 1.2rem !important;
    }
    &:focus-within {
      box-shadow: 0 0 0.25rem ${colors.pacificBlue};
    }
  })
`;

export const CreditCardIconContainer = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.5rem 0;
`;
